import { useEffect, useState } from 'react';
import { Card, Row, Col, Form, Button, Alert, Spinner, Table, Badge } from 'react-bootstrap';
import { FaWallet } from 'react-icons/fa';
import { api } from '../api/client';
import { useAuth } from '../auth/AuthContext';
import { formatDateTime } from '../shared/dateFormat';

const TYPE_BADGE = {
  credit: 'success',
  release: 'info',
  hold: 'warning',
  debit: 'danger',
};

export default function StudentWallet() {
  const { refresh } = useAuth();
  const [data, setData] = useState(null);
  const [amount, setAmount] = useState('');
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState({ type: '', text: '' });

  const load = async () => {
    try {
      setData(await api.get('/student/wallet'));
    } catch (e) { setMsg({ type: 'danger', text: e.message }); }
  };
  useEffect(() => { load(); }, []);

  const topup = async (e) => {
    e.preventDefault();
    const amt = Number(amount);
    if (!amt || amt <= 0) return;
    if (!window.confirm(`Top up ₹${amt} to your wallet? (manual placeholder — gateway comes later)`)) return;
    setBusy(true);
    try {
      await api.post('/student/wallet/topup', { amount: amt });
      setMsg({ type: 'success', text: `Topped up ₹${amt}.` });
      setAmount('');
      await load();
      await refresh();
    } catch (e) { setMsg({ type: 'danger', text: e.message }); }
    finally { setBusy(false); }
  };

  if (!data) return <div className="text-center py-5"><Spinner /></div>;

  return (
    <>
      <h3 className="mb-4">My Wallet</h3>
      {msg.text && <Alert variant={msg.type} dismissible onClose={() => setMsg({ type: '', text: '' })}>{msg.text}</Alert>}

      <Row>
        <Col md={4}>
          <Card className="shadow-sm mb-3">
            <Card.Body className="text-center">
              <FaWallet size={36} className="text-primary mb-2" />
              <Card.Title>Available balance</Card.Title>
              <h2 className="mb-0">₹{Number(data.balance).toFixed(2)}</h2>
              {Number(data.held) > 0 && (
                <small className="text-muted d-block mt-2">+ ₹{Number(data.held).toFixed(2)} held by active bookings</small>
              )}
            </Card.Body>
          </Card>
        </Col>
        <Col md={8}>
          <Card className="shadow-sm mb-3">
            <Card.Body>
              <Card.Title>Top up wallet</Card.Title>
              <Form onSubmit={topup} className="d-flex gap-2">
                <Form.Control type="number" min={1} placeholder="Amount in ₹" value={amount} onChange={(e) => setAmount(e.target.value)} required />
                <Button type="submit" disabled={busy}>{busy ? 'Processing...' : 'Top up'}</Button>
              </Form>
              <small className="text-muted">Manual placeholder — real PayUMoney / Razorpay integration in Phase 5.</small>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      <h5 className="mt-4">Transactions</h5>
      <Table bordered hover responsive className="bg-white">
        <thead className="table-dark"><tr><th>When</th><th>Type</th><th>Reason</th><th className="text-end">Amount</th><th className="text-end">Available after</th><th className="text-end">Held after</th></tr></thead>
        <tbody>
          {data.transactions.length === 0 && <tr><td colSpan={6} className="text-center text-muted">No transactions yet</td></tr>}
          {data.transactions.map((t) => (
            <tr key={t.id}>
              <td>{formatDateTime(t.created_at)}</td>
              <td><Badge bg={TYPE_BADGE[t.type] || 'secondary'}>{t.type}</Badge></td>
              <td>{t.reason}</td>
              <td className="text-end">₹{Number(t.amount).toFixed(2)}</td>
              <td className="text-end">₹{Number(t.balance_after).toFixed(2)}</td>
              <td className="text-end">₹{Number(t.held_after ?? 0).toFixed(2)}</td>
            </tr>
          ))}
        </tbody>
      </Table>
    </>
  );
}
